import { render, staticRenderFns } from "./assetImportDialog.vue?vue&type=template&id=71275b71&scoped=true"
import script from "./assetImportDialog.vue?vue&type=script&lang=js"
export * from "./assetImportDialog.vue?vue&type=script&lang=js"
import style0 from "./assetImportDialog.vue?vue&type=style&index=0&id=71275b71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71275b71",
  null
  
)

export default component.exports